import { NgModule, APP_INITIALIZER, inject } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoginModule } from './modules/login/login.module';
import { CoreModule } from './core/core.module';
import { LayoutModule } from './layout/layout.module';
import { NAVIGATION_ITEMS } from './layout/navigation.service';
import { NAVIGATION } from './constant/navigation';
import { HomeModule } from './modules/home/home.module';
import { ApiModule } from './api/api/api.module';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ApiModule,
    HttpClientModule,
    LoginModule,
    CoreModule,
    LayoutModule,
    HomeModule
  ],
  providers: [
    {
      provide: NAVIGATION_ITEMS,
      useValue: NAVIGATION,
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
